import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../../identity/user.service';

/**
 * Guard that prevents user from visiting admin panel if he
 * doesn't have access to it.
 */
@Injectable({
  providedIn: 'root'
})
export class AdminPanelGuard  {
  constructor(private userService: UserService, private router: Router) {
  }
  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {

    let canActivatePanel = await this.userService.hasAdminPanelAccess();
    if (canActivatePanel == false || canActivatePanel == null) {
      return this.router.parseUrl('/management/me');
    }
    else {
      return true;
    }
  }
  
}
